import React from 'react';
import PropTypes from 'prop-types';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import classNames from 'classnames';
import css from './LinkGroupHeader.css';
import { getCustomSourceLogo } from '../../utils/sources';

const LinkGroupHeader = ({ title = '', logo = '', subTitle = '', expanded = false }) => {
    const getLogo = () => {
        if (!logo) {
            return <div className={classNames(css.logo, css.emptyLogo)} />;
        }
        const CustomLogo = getCustomSourceLogo(logo);
        return CustomLogo ? (
            <CustomLogo className={classNames(css.logo, css.customLogo)} />
        ) : (
            <img className={css.logo} src={logo} />
        );
    };

    return (
        <div className={classNames(css.container, { [css.expanded]: expanded })}>
            {getLogo()}
            <div className={css.titleContainer}>
                <div className={css.title}>{title}</div>
                <div className={css.subTitle}>{subTitle}</div>
            </div>
            <div className={css.arrowArea}>
                <ArrowDownIcon className={css.arrow} />
            </div>
        </div>
    );
};

LinkGroupHeader.propTypes = {
    title: PropTypes.string,
    logo: PropTypes.string,
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    expanded: PropTypes.bool,
};

export default LinkGroupHeader;
